import * as styles from "./AutocompleteIcon.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";
import { Icon } from "@frontend/components/atoms/Icon";

import type { AutocompleteIconProps } from "./Autocomplete.types";

export function AutocompleteIcon({
  className,
  children,
  ...props
}: AutocompleteIconProps): JSX.Element {
  return (
    <BaseAutocomplete.Icon
      data-slot="autocomplete-icon"
      className={clsx(styles.icon, className)}
      {...props}
    >
      {children ?? <Icon name="Search" size="sm" />}
    </BaseAutocomplete.Icon>
  );
}
